export default __webpack_public_path__ + "static/media/college-logo.ab177558.png";